import { render, staticRenderFns } from "./CupsyCies.vue?vue&type=template&id=2bec8580&scoped=true"
import script from "./CupsyCies.vue?vue&type=script&lang=js"
export * from "./CupsyCies.vue?vue&type=script&lang=js"
import style0 from "./CupsyCies.vue?vue&type=style&index=0&id=2bec8580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec8580",
  null
  
)

export default component.exports